module.exports = __webpack_public_path__ + "img/Quizz_0003_evitar-atropelamentos.6edf9227.png";